module.exports = __webpack_public_path__ + "static/cfd-4e2a01af757a3ffffc14a34a109f6bac.gif";